@if (alert) {
  <div class="popup-wrap" [class.leaving]="leaving">
    <div class="popup-card" (click)="onOpen()">
      <div class="popup-avatar">
        <div class="popup-pulse"></div>
        <i class="pi pi-bell popup-bell"></i>
      </div>

      <div class="popup-content">
        <div class="popup-label">
          <span class="popup-label-dot"></span>
          {{ typeLabel }}
        </div>
        <h5 class="popup-title" [title]="alert.title">{{ alert.title }}</h5>
        <p class="popup-desc">{{ alert.message }}</p>
      </div>

      <button
        type="button"
        class="popup-close"
        aria-label="Dismiss notification"
        (click)="onDismiss($event)"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
}
